import React from 'react';
import { saveAs } from 'file-saver';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Button, Grid, Modal, LinkAsButton,
} from '@printdeal/ui-library';

import ArtWorkThumbnail from '../../../ArtworkThumbnail';

import { FileInfoLineItem } from '../../../../../../types/order/Order';
import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface DownloadFilesModalProps {
  fileInfo: FileInfoLineItem;
  handleCloseModal: (eventName: string) => void;
}

const DownloadFilesModal = ({ fileInfo, handleCloseModal }: DownloadFilesModalProps) => {
  const intl = useIntl();

  const downloadFile = (upload: string, name: string) => {
    saveAs(upload, name);
    dispatchAccountEvent('order_detail_interaction', 'download_file');
  };

  return (
    <Modal
      isOpen
      onClose={() => handleCloseModal('close_modal_download_file_by_button')}
      dismissLabel={intl.formatMessage({
        id: 'account.general.modal.close',
        defaultMessage: 'Close',
      })}
      title={intl.formatMessage({
        id: 'download.files.modal.title',
        defaultMessage: 'Download files',
      })}
    >
      <Modal.Content>
        <div className="pd-m-5 pd-mt-3">
          <FormattedMessage id="download.files.modal.text" defaultMessage="Download your delivered files. These files did you upload" />
        </div>
        {fileInfo.files.map(({ preview, upload, name }) => (
          <div className="pd-m-5" key={name}>
            <div className="pd-border-t pd-py-5">
              <Grid className="pd-grid-cols-[1fr,3fr,auto] pd-gap-4">
                <Grid.Item>
                  <ArtWorkThumbnail
                    uploadsUrl={preview}
                    isDeliveredFileValid={fileInfo.valid}
                  />
                </Grid.Item>
                <Grid.Item>
                  <h3 className="pd-truncate">{name}</h3>
                </Grid.Item>
                <Grid.Item className="pd-text-right pd-text-sm">
                  <LinkAsButton
                    as="button"
                    onClick={() => downloadFile(upload, name)}
                    variant="secondary"
                    iconBefore="download"
                  >
                    <FormattedMessage id="account.details.button.download.file" defaultMessage="Download file" />
                  </LinkAsButton>
                </Grid.Item>
              </Grid>
            </div>
          </div>
        ))}
      </Modal.Content>
      <Modal.Footer className="pd-text-right">
        <Button
          variant="primary"
          onClick={() => handleCloseModal('close_modal_download_file_by_button')}
        >
          <FormattedMessage id="download.files.modal.close" defaultMessage="Close" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DownloadFilesModal;
